import React from 'react';
import { Eye, X } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

// Shown at the top of the site when an admin is previewing as a member class
// (opened via the navbar "View as…" control, ?viewAs=<class>).
export default function PreviewBanner() {
  const { isPreview, previewClass, exitPreview, classLabel } = useAuth();
  if (!isPreview) return null;
  return (
    <div
      data-testid="preview-banner"
      className="flex items-center justify-center gap-3 px-4 py-2 text-sm font-title"
      style={{ background: 'var(--gold)', color: '#3a2c06' }}
    >
      <Eye size={16} />
      <span>
        Previewing as <strong>{classLabel(previewClass)}</strong> — this is how these members see the site. Editing is disabled.
      </span>
      <button
        onClick={exitPreview}
        data-testid="exit-preview-btn"
        className="flex items-center gap-1 px-2.5 py-1 rounded"
        style={{ background: '#3a2c06', color: 'var(--cream)' }}
      >
        <X size={13} /> Exit preview
      </button>
    </div>
  );
}
